import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { ApiResponse } from '@interfaces/api/api.interface';
import { ShoppingCartGetItemsResponseInterface } from '@interfaces/shopping-cart/shopping-cart-get-items-response-interface';
import { ShoppingCartAddItemInterface } from '@interfaces/shopping-cart/shopping-cart-add-item-interface';
import { AmountInterface } from '@interfaces/shopping-cart/amount-interface';

@Injectable({
  providedIn: 'root',
})
export class ShoppingCartService {
  private http = inject(HttpClient);
  private shoppingCartEnpoints = environment.endpoints.shoppingCart;
  private api = environment.API_URL;
  // private locale = inject(LanguageService);

  public getShoppingCartItems(): Observable<ApiResponse<ShoppingCartGetItemsResponseInterface>> {
    // let httpParams = new HttpParams();
    // httpParams = httpParams.set('locale', this.locale.currentLanguage().toUpperCase());
    return this.http.get<ApiResponse<ShoppingCartGetItemsResponseInterface>>(
      `${this.api}/${this.shoppingCartEnpoints}`
      // ,
      // {
      //   params: httpParams,
      // }
    );
  }

  public createShoppingCartItem(products: ShoppingCartAddItemInterface[]): Observable<ApiResponse<void>> {
    return this.http.put<ApiResponse<void>>(`${this.api}/${this.shoppingCartEnpoints}`, products);
  }

  public updateShoppingCartItem(itemID: string, amount: AmountInterface): Observable<ApiResponse<void>> {
    return this.http.patch<ApiResponse<void>>(`${this.api}/${this.shoppingCartEnpoints}/${itemID}`, amount);
  }

  public deleteShoppingCartItem(itemID: string): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.api}/${this.shoppingCartEnpoints}/${itemID}`);
  }
}
